"use strict";

var LoggerInstance = require("js-logger").get("ContactUsApi");

var AbstractApi = require("./AbstractApi");

var StringConstants = require("../constants/StringConstants");

var ContactUsApi = class extends AbstractApi {
	submitContactUsRequest(contactUsRequestData) {
		return this.post({
			data: contactUsRequestData,
			url: "/api/contactus",
			reCAPTCHA: true,
			reCAPTCHAAction: StringConstants.ReCAPTCHAActions.Contact
		});
	}
};

module.exports = new ContactUsApi();
